import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
    declarations: [],
    imports: [],
    exports: [BrowserModule, BrowserAnimationsModule]
})
export class CoreModule {}
